<template>
  <dx-popup
    :visible="display"
    :show-title="false"
    :drag-enabled="false"
    width="550"
    height="350"
  >
    <div id="ld">
      <div class="text-center" style="width:100%;">Loading...</div>
      <div
        class="spinner-border"
        role="status"
        aria-hidden="true"
        style="margin-left:45%;"
      ></div>
    </div>
  </dx-popup>
</template>

<script>
export default {
  components: {
    // DxPopup
  },
  props: {
    display: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
#ld {
  width: 100% !important;
  height: 100% !important;
  margin-top: 30%;
  /* margin-left: 40%; */
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadPanel.vue